import React from 'react';
import PropTypes from 'prop-types';
import { BreakpointsConsumer } from './BreakpointsProvider';

export default class On extends React.Component {
  static propTypes = {
    /** provide a statement that evaluates to 'true' or 'false', or a function that returns a boolean value.
     * If a function is provided, the first argument will be an object containing breakpoints and window size values. */
    renderIf: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired,
    /** React Elements to be conditionally rendered if `renderIf` prop evaluates to true */
    children: PropTypes.any
  };

  static defaultProps = {
    renderIf: true
  };

  render() {
    return (
      <BreakpointsConsumer>
        {breakpointsAndDims => {
          if (this.checkPropFormat(breakpointsAndDims)) {
            return this.props.children;
          }
          return null;
        }}
      </BreakpointsConsumer>
    );
  }

  checkPropFormat = breakpointsAndDims => {
    const { renderIf } = this.props;
    if (typeof renderIf === 'boolean') {
      return renderIf;
    } else if (typeof renderIf === 'function') {
      return renderIf(breakpointsAndDims);
    }
    // todo: log props not formated correctly (or bug)
    return true;
  };
}
